import { initiateNewTransactionTrackingThunk } from './thunks/initiateNewTransactionTrackingThunk';
/**
 * Transactions have to be registered for them to be tracked inside the redux store and monitored for re-orgs.
 */
export const registerNewTransaction = async (arg) => {
    const { chainId, signerAddress, transactionResponse, dispatch, title, extraData } = arg;
    dispatch(initiateNewTransactionTrackingThunk({
        chainId,
        signerAddress,
        transactionResponse,
        title,
        extraData: extraData !== null && extraData !== void 0 ? extraData : {},
    }));
};
export const registerNewTransactionAndReturnQueryFnResult = async (arg) => {
    registerNewTransaction(arg);
    return {
        data: {
            hash: arg.transactionResponse.hash,
            chainId: arg.chainId,
        },
    };
};
//# sourceMappingURL=registerNewTransaction.js.map